import { render, staticRenderFns } from "./ReservationDetailsPage.vue?vue&type=template&id=77be073a"
import script from "./ReservationDetailsPage.vue?vue&type=script&lang=js"
export * from "./ReservationDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./ReservationDetailsPage.vue?vue&type=style&index=0&id=77be073a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports